import { gsap, ScrollTrigger } from '../gsap/setup';

export function initFooter($header) {
  const $footer = $('.page-footer');
  const $logo = $footer.find('.page-footer__logo');
  const noColorChange = document.body.classList.contains('no-color-change');

  if (!noColorChange) {
    ScrollTrigger.create({
      trigger: $footer[0],
      start: 'top 100px',
      end: 'bottom top',
      onToggle: ({ isActive }) => {
        if (isActive) {
          $header.addClass('is-dark');
        } else {
          $header.removeClass('is-dark');
        }
      },
    });
  }

  if (noColorChange || !$logo.length) return;

  const tl = gsap.timeline({
    repeat: -1,
    scrollTrigger: {
      trigger: $footer[0],
      start: 'top bottom',
      end: 'bottom top',
      toggleActions: 'play pause resume pause',
    },
  });

  tl.to($logo[0], {
    color: '#F3E9CC',
    duration: 1,
  })
    .to($logo[0], {
      color: '#8383E0',
      duration: 1,
    })
    .to($logo[0], {
      color: '#EAC15B',
      duration: 1,
    })
    .to($logo[0], {
      color: '#84C4B3',
      duration: 1,
    })
    .to($logo[0], {
      color: '#B9DDDD',
      duration: 1,
    });
}
